import React, { Component } from 'react';
import Modal from 'react-modal';
import DialogButton from './DialogButton';

class Dialog extends Component {
  render () {
    const {
      open,
      className,
      onClose,
      title,
      children,
      actions,
    } = this.props;

    return (
      <Modal
        ariaHideApp={false}
        closeTimeoutMS={200}
        className={className}
        isOpen={open}
        onRequestClose={onClose}
      >
        <div className="mce-container mce-panel mce-floatpanel mce-window mce-in" hidefocus="1" aria-label="서식">
          <div className="mce-window-head">
            <div className="mce-title">{title}</div>
          </div>

          <div className="mce-container-body mce-window-body">
            {children}
          </div>

          <div className="mce-container mce-panel mce-foot" hidefocus="1" tabIndex="-1" role="group">
            <div className="mce-container-body mce-flow-layout">
              {actions.map(action => <DialogButton key={action.label} primary={action.primary} onClick={action.handler}>
                {action.label}
              </DialogButton>
              )}
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default Dialog;
